function userNeedsDate(store) {
  if (!store.getters['app/isMasteryApp']) {
    const user = store.getters['session/currentUser'];
    if (user) {
      // if no date set
      return !user.estimatedTestDate && !user.expectedGraduationDate;
    } else {
      return false;
    }
  }
}

export function shouldAskGraduation(store) {
  if (!store.getters['app/isMasteryApp']) {
    const pv = store.getters['productVars/get']['gradOnboarding'];
    return pv && pv.value === 'true';
  }
}

export function shouldAskTest(store) {
  if (!store.getters['app/isMasteryApp']) {
    const pv = store.getters['productVars/get']['disable_test_date_screen'];
    return !(pv && pv.value === 'true');
  }
}

export function onboardingEnabled(store) {
  return shouldAskGraduation(store) || shouldAskTest(store);
}

export function shouldEnterOnboarding(store) {
  return onboardingEnabled(store) && userNeedsDate(store);
}

export function onboardingCategory(store) {
  const pv = store.getters['productVars/get']['onboardingCategory'];
  if (pv) {
    return pv.value;
  }
}